import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, colors } from '@mui/material';
import { FilePicker } from 'components';
import validate from 'validate.js';

import { enqueueSnackbar } from 'actions';
import { SetFormState, GenerateHuaweiRemoteAnalysis } from '../../../actions/HuaweiRemoteAnalysisActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const schema = {
	huaweiRemoteAnalysisInput: {
		presence: { allowEmpty: false, message: 'is required' },
	},
};

const HuaweiRemoteAnalysisForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.huaweiRemoteAnalysisReducer.formState.huaweiRemoteAnalysis);
	const user = useSelector((state) => state.session.user);

	useEffect(() => {
		const errors = validate(formState.values, schema);
		setFormState({
			huaweiRemoteAnalysis: {
				...formState,
				isValid: !errors,
				errors: errors || {},
			}
		});
	}, [formState.values]);

	const _onChangeInput = (event) => {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			setFormState({
				huaweiRemoteAnalysis: {
					...formState,
					values: {
						...formState.values,
						huaweiRemoteAnalysisInput: file,
					},
					touched: {
						...formState.touched,
						huaweiRemoteAnalysisInput: true,
					},
				}
			});
		}
	};

	const _generate = () => {
		if (formState.values.huaweiRemoteAnalysisInput.size > 100000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 100MB', options: { variant: 'warning' } }));
			return;
		}
		dispatch(GenerateHuaweiRemoteAnalysis(formState.values.huaweiRemoteAnalysisInput, user.id));
	};

	return (
		<Card className={classes.content}>
			<CardHeader title="Huawei Remote Analysis" />
			<Divider />
			<CardContent>
				<Grid item md={4} xs={12}>
					<FilePicker value={formState.values.huaweiRemoteAnalysisInput?.name} onChange={_onChangeInput} accept=".zip" />
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Button className={classes.generate} onClick={_generate} variant="contained" disabled={!formState.isValid}>Generate</Button>
			</CardActions>
		</Card>
	);
};

export default HuaweiRemoteAnalysisForm;
